import React from 'react';
import { Input, Checkbox } from '../../../../common/components/formControls';
import { Field } from 'redux-form';
import validators from '../../../../common/services/validators';

const VoucherForm = ({ t, enabled }) => {
	return (
		<div>
			<Field name='additionalFee' component={Input} type='text' label={t('PaymentMethod_AdditionalFee')} validate={[validators.number]} />
			<Field name='isAdditionalFeePercentage' component={Checkbox} label={t('PaymentMethod_IsAdditionalFeePercentage')} help={t('PaymentMethod_AdditionalFeeComplianceNote')} normalize={v => !!v} />
		</div>
	);
};


export default VoucherForm;